var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Video, VideoOff } from "lucide-react";
import { cn } from "../../lib/utils";
import Tooltip from "./Tooltip";
var VideoAudioSwitch = function (_a) {
    var isVideoMode = _a.isVideoMode, onToggle = _a.onToggle, _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.showTooltip, showTooltip = _c === void 0 ? true : _c, _d = _a.tooltipPosition, tooltipPosition = _d === void 0 ? "left" : _d, className = _a.className, props = __rest(_a, ["isVideoMode", "onToggle", "size", "showTooltip", "tooltipPosition", "className"]);
    // Determine sizes based on the size prop
    var sizeClasses = {
        sm: "h-6 w-16",
        md: "h-6 w-16",
        lg: "h-6 w-24",
    };
    var iconSizes = {
        sm: 14,
        md: 16,
        lg: 20,
    };
    var thumbSizes = {
        sm: "h-6 w-6",
        md: "h-8 w-8",
        lg: "h-10 w-10",
    };
    // Tooltip content based on current mode
    var tooltipContent = isVideoMode ? "Switch to Audio Mode" : "Switch to Video Mode";
    // The switch component
    var switchComponent = (React.createElement("div", __assign({ className: cn("relative cursor-pointer rounded-full transition-colors duration-300", sizeClasses[size], isVideoMode ? "bg-bot-primary" : "bg-gray-400", className), onClick: onToggle }, props),
        React.createElement("div", { className: cn("absolute top-1/2 -translate-y-1/2 rounded-full bg-white shadow-md flex items-center justify-center transition-transform duration-300", thumbSizes[size], isVideoMode ? "translate-x-[calc(100%-2px)]" : "translate-x-[2px]") }, !isVideoMode ? (React.createElement(Video, { size: iconSizes[size], className: "text-bot-primary" })) : (React.createElement(VideoOff, { size: iconSizes[size], className: "text-gray-500" })))));
    // Wrap with tooltip if showTooltip is true
    if (showTooltip) {
        return (React.createElement(Tooltip, { content: tooltipContent, position: tooltipPosition }, switchComponent));
    }
    return switchComponent;
};
export { VideoAudioSwitch };
